import { UpperCasePipe } from '../../filters/upper-case.pipe';
import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { CurrencyPipe } from '../../filters/currency.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Config from '../../utils/config.service';
import UserService from '../../services/user.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'card-service-instant',
	templateUrl: './card-service-instant.component.html',
	imports: [ CommonModule, UpperCasePipe, LowerCasePipe, CurrencyPipe, TranslatePipe, FormsModule, RouterLink ]
})
export class CardServiceInstantComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private userService: UserService = inject(UserService);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() service: any | undefined;
	@Input() isNarrow: any | undefined;
	
	vm: any = undefined;
	walletSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.handleComponentInit();
		
		// this.angularStateHelperService.scopeWF(this, this.userService.getWallet, this.handleWalletUpdate, true);
		this.walletSubscription = this.angularBroadcastHelperService.onEvent(this, "walletChanged", (event, newWallet) => {
			this.handleWalletUpdate(newWallet);
		});
		this.userService.getWallet(); // TODO ANGULAR_2: should this be inside an interval?
	}
	
	ngOnDestroy() {
		if (this.walletSubscription) {
			this.walletSubscription.unsubscribe();
		}
	}
	
	handleComponentInit() {
		var isDaylightSavingTime: any = moment().isDST();
		var timezoneOffsetHours: any = isDaylightSavingTime ? 3 : 2;
		var startTimeHours: any = (24 + this.vm.service.startTimeInHours + timezoneOffsetHours) % 24;
		var startTime: any = ('0' + startTimeHours).slice(-2) + ':00';
		var endTimeHours: any = (24 + this.vm.service.endTimeInHours + timezoneOffsetHours) % 24;
		var endTime: any = ('0' + endTimeHours).slice(-2) + ':00';
		var weekendStartTimeHours, weekendStartTime, weekendEndTimeHours, weekendEndTime;
		if (this.vm.service.weekendStartTimeInHours && this.vm.service.weekendEndTimeInHours) {
			weekendStartTimeHours = (24 + this.vm.service.weekendStartTimeInHours + timezoneOffsetHours) % 24;
			weekendStartTime = ('0' + weekendStartTimeHours).slice(-2) + ':00';
			weekendEndTimeHours = (24 + this.vm.service.weekendEndTimeInHours + timezoneOffsetHours) % 24;
			weekendEndTime = ('0' + weekendEndTimeHours).slice(-2) + ':00';
		}
		var origin: any = this.session.getSession().user.origin;
		var timeZoneInfo: any = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_1');
		var areaInfo: any = this.angularFilterHelperService.translate('Booking.Instant.Info_Nurse_Area1');
		if (origin == 'minudoc.fi') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_2');
			areaInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Nurse_Area2');
		} else if (origin == 'minudoc.lv') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_3');
			areaInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Nurse_Area3');
		} else if (origin == 'minudoc.lt') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_4');
			areaInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Nurse_Area4');
		} else if (origin == 'minudoc.pl') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_5');
			areaInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Nurse_Area5');
		}
		this.vm.getBusinessWalletLabel = this.getBusinessWalletLabel;
		this.vm.forceHidePrice = (origin == 'siffi.com');
		switch (this.vm.service.subcategory) {
			case 'PARTNERS':
			{
				this.vm.imageUrl = 'img/od-partners.png';
				this.vm.customImageStyle = {'width': '140px', 'margin':'10px'};
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Partners.Title')
				);
				this.vm.text = this.angularFilterHelperService.translate('Partners.Card.Description');
				this.vm.link = ['/partners'];
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				this.vm.hidePrice = true;
				break;
			}
			case 'PRE_VISIT':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-medical-workers.svg';
				this.vm.customImageStyle = {'margin-top':'20px', 'margin-bottom':'20px'};
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_PreVisit')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_PreVisit');
				this.vm.link = ['/pre-visit'];
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'COACHING_TOPICS':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-coaching-topics.png';
				this.vm.customImageStyle = {'width': '140px', 'margin':'10px'};
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_Coaching_Topics')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_Coaching_Topics');
				this.vm.link = [''];
				this.vm.queryParams = {showCoaching: true, category: 'COACH_SUPERVISOR'};
				this.vm.currency = this.config.getBookingConfig().Instant.Coach.DEFAULT_CURRENCY;
				this.vm.duration = this.config.getBookingConfig().Instant.Coach.DEFAULT_DURATION_MINUTES;
				this.vm.price = this.config.getBookingConfig().Instant.Coach.DEFAULT_PRICE;
				this.vm.service.pricing = { price: this.vm.price };
				this.vm.service.furtherSubcategory = ['COACHING', 'COACH_SUPERVISOR'];
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				this.vm.isMentalHealth = true;
				this.vm.isCoaching = true;
				break;
			}
			case 'HOME_VISITS':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-nurse.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_Nurse')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_Nurse');
				this.vm.currency = this.config.getBookingConfig().Instant.Nurse.DEFAULT_CURRENCY;
				this.vm.duration = this.vm.service.timePerPrice || this.config.getBookingConfig().Instant.Nurse.DEFAULT_DURATION_MINUTES;
				this.vm.info = this.angularFilterHelperService.translate('Booking.Instant.Info_Nurse') + areaInfo;
				this.vm.link = [''];
				this.vm.queryParams = {category: 'HOME_VISITS'};
				this.vm.btnText = this.angularFilterHelperService.translate('Booking.Instant.Button2');
				this.vm.price = this.vm.service.price || this.config.getBookingConfig().Instant.Nurse.DEFAULT_PRICE;
				this.vm.service.pricing = { price: this.vm.price };
				this.vm.service.furtherSubcategory = 'NURSE';
				break;
			}
			case 'PHARMACIST':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-pharma.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_Pharmacist').replace('с апт', 'с <br/>апт')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_Pharmacist');
				this.vm.currency = this.config.getBookingConfig().Instant.Pharmacist.DEFAULT_CURRENCY;
				this.vm.duration = this.vm.service.timePerPrice || this.config.getBookingConfig().Instant.Pharmacist.DEFAULT_DURATION_MINUTES;
				this.vm.link = ['/booking/instant'];
				this.vm.queryParams = {category: this.vm.service.subcategory, origin: origin};
				this.vm.btnText = this.angularFilterHelperService.translate('Booking.Instant.Button');
				this.vm.price = this.vm.service.price || this.config.getBookingConfig().Instant.Pharmacist.DEFAULT_PRICE;
				this.vm.service.pricing = { price: this.vm.price };
				this.vm.service.furtherSubcategory = 'PHARMACIST';
				
				if (typeof this.vm.service.endTimeInHours === 'number') {
					this.setInstantServiceAvailableTime(startTime, endTime, timeZoneInfo, weekendStartTime, weekendEndTime);
				}
				
				break;
			}
			case 'PRESCRIPTION':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-prescription.svg';
				this.vm.customImageStyle = {'max-width': '70%'};
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_Prescription')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_Prescription');
				this.vm.currency = this.config.getBookingConfig().Instant.Prescription.DEFAULT_CURRENCY;
				this.vm.duration = this.vm.service.timePerPrice 
					|| this.config.getBookingConfig().Instant.Prescription.DEFAULT_DURATION_MINUTES;
				if (origin !== 'minudoc.ee') {
					this.vm.link = ['/booking/prescription'];
					this.vm.queryParams = {origin: origin};
				} else {
					this.vm.link = ['/prescription-list'];
					this.vm.queryParams = {origin: origin};
				}
				this.vm.btnText = this.angularFilterHelperService.translate('Booking.Prescription.Extend');
				this.vm.price = this.vm.service.price || this.config.getBookingConfig().Instant.Prescription.DEFAULT_PRICE;
				this.vm.service.pricing = { price: this.vm.price };
				this.vm.service.furtherSubcategory = ['GENERAL_PRACTITIONER', 'FAMILY_PHYSICIAN'];
				
				if (typeof this.vm.service.endTimeInHours === 'number') {
					this.setInstantServiceAvailableTime(startTime, endTime, timeZoneInfo, weekendStartTime, weekendEndTime);
				}
				
				break;
			}
			case 'MENTAL_CHECK':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-mental.svg';
				this.vm.customImageStyle = {'margin-top':'20px', 'margin-bottom':'10px'};
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_Mental')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_Mental');
				this.vm.currency = this.config.getBookingConfig().Instant.Doctor.DEFAULT_CURRENCY;
				this.vm.duration = this.vm.service.timePerPrice;
				this.vm.link = ['/mental-health-services'];
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				this.vm.price = this.vm.service.price || this.config.getBookingConfig().Instant.Doctor.DEFAULT_PRICE;
				this.vm.service.pricing = { price: this.vm.price };
				this.vm.service.furtherSubcategory = ['GENERAL_PRACTITIONER', 'MENTAL_CHECK'];
				this.vm.isMentalHealth = true;
				
				if (typeof this.vm.service.endTimeInHours === 'number') {
					this.setInstantServiceAvailableTime(startTime, endTime, timeZoneInfo, weekendStartTime, weekendEndTime);
				}
				
				break;
			}
			case 'WEIGHT_LOSS_CONSULTATION':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-weightloss.svg';
				this.vm.customImageStyle = {'margin-top':'20px', 'margin-bottom':'10px'};
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_Weight_Loss')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_Weight_Loss');
				this.vm.currency = this.config.getBookingConfig().Instant.Doctor.DEFAULT_CURRENCY;
				this.vm.link = [''];
				this.vm.queryParams = {weightLossServiceSupport: true};
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				this.vm.price = this.vm.service.price || this.config.getBookingConfig().Instant.WeightLoss.DEFAULT_PRICE;
				this.vm.service.pricing = { price: this.vm.price };
				this.vm.service.furtherSubcategory = ['GENERAL_PRACTITIONER', 'WEIGHT_LOSS_CONSULTATION'];
				break;
			}
			default:
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-doctor.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('Booking.Instant.Title_Default').replace('с сем', 'с <br/>сем')
				);
				this.vm.text = this.angularFilterHelperService.translate('Booking.Instant.Text_Default');
				this.vm.currency = this.config.getBookingConfig().Instant.Doctor.DEFAULT_CURRENCY;
				this.vm.duration = this.vm.service.timePerPrice || this.config.getBookingConfig().Instant.Doctor.DEFAULT_DURATION_MINUTES;
				this.vm.link = ['/booking/instant'];
				this.vm.queryParams = {category: this.vm.service.subcategory, origin: origin};
				this.vm.btnText = this.angularFilterHelperService.translate('Booking.Instant.Button');
				this.vm.price = this.vm.service.price || this.config.getBookingConfig().Instant.Doctor.DEFAULT_PRICE;
				this.vm.service.pricing = { price: this.vm.price };
				this.vm.service.furtherSubcategory = ['GENERAL_PRACTITIONER', 'FAMILY_PHYSICIAN'];
				
				if (typeof this.vm.service.endTimeInHours === 'number') {
					this.setInstantServiceAvailableTime(startTime, endTime, timeZoneInfo, weekendStartTime, weekendEndTime);
				}
			}
		}
		
		this.handlePriceUpdate();
	}
	
	setInstantServiceAvailableTime(startTime, endTime, timeZoneInfo, weekendStartTime, weekendEndTime) {
		if (this.vm.service.workingDaysOnly) {
			this.vm.info = this.angularFilterHelperService.translate('Booking.Instant.Info_Weekdays')
				.replace('%s', startTime)
				.replace('%e', endTime) + timeZoneInfo;
		} else {
			if (weekendStartTime && weekendEndTime) {
				this.vm.info = this.angularFilterHelperService.translate('Booking.Instant.Info_Weekend_Restricted')
					.replace('%s', startTime).replace('%e', endTime)
					.replace('%ws', weekendStartTime).replace('%we', weekendEndTime) + timeZoneInfo;
			} else {
				this.vm.info = this.angularFilterHelperService.translate('Booking.Instant.Info_Default')
					.replace('%s', startTime)
					.replace('%e', endTime) + timeZoneInfo;
			}
		}
	}
	
	handleWalletUpdate(wallet) {
		if (this.angularHelperService.equals(wallet, this.vm.wallet)) return;
		this.vm.wallet = wallet || {};
		this.handlePriceUpdate();
	}
	
	handlePriceUpdate() {
		if (this.vm.service.subcategory === 'PARTNERS' || this.vm.service.subcategory === 'PRE_VISIT' || this.vm.service.subcategory === 'WEIGHT_LOSS_CONSULTATION') {
			this.vm.isInitialized = true;
			return;
		}
		this.userService.getWalletWithPrice(this.vm.service)
			.then((usedWallet) => {
				this.vm.isCoveredByBusinessWallet = (!usedWallet.price || usedWallet.coPayWallet) && this.vm.service.pricing.price;
				if (usedWallet.alternative) {
					if (usedWallet.coPayWallet) {
						this.vm.walletName = usedWallet.coPayWallet.wallet.name;
						this.vm.insuranceCoPay = true;
					} else {
						this.vm.walletName = usedWallet.wallet.name;
					}
				}
				this.vm.isInitialized = true;
			})
			.catch(console.error);
	}
	
	getBusinessWalletLabel() {
		if (this.vm.insuranceCoPay) {
			return 'Services.Other.Insurance_Cover';
		} else if (this.vm.walletName?.toLowerCase() === 'iizi') {
			return 'Services.Other.Package_By';
		} else {
			return 'Services.Other.Covered_By';
		}
	}
	
}
